<div class="alert alert-danger">
    You are not authorized to access this resource.
</div>